module.exports = __webpack_public_path__ + "img/dd3.6d4157c5.jpg";